<div class="detailsViewContainer_Conatiner">
    <app-team-member-details-view *ngIf="!isOrgDetails" class="detailsViewContainer_teamMemberDetails" [counterpartId]="entity"></app-team-member-details-view>
    <app-org-details-view *ngIf="isOrgDetails"></app-org-details-view>
</div>